// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-select.is-invalid[data-v-121d952d]  .vs__dropdown-toggle{border-color:#dc3545}.vue-select[data-v-121d952d]  .vs__dropdown-toggle{border-radius:0;border-color:#ced4da;height:38px}", ""]);
// Exports
module.exports = exports;
